import axios from '@/api';
import store from "../store";
import router, {
    ayscRoutes,
    resetRouter
} from "@/router";
import { filterAsyncRoutes } from '@/utils/app.js'
/**
 * @param {string} token 
 */
export function setToken(token = "") {
    localStorage.setItem('flo_token', JSON.stringify(token))
}
export function getToken() {
    return JSON.parse(localStorage.getItem('flo_token'))
}
/**
 * @param {string} name 
 */
export function setName(name = "") {
    store.commit("user/setName", name)
    localStorage.setItem('flo_name', JSON.stringify(name))
}
export function getName() {
    return JSON.parse(localStorage.getItem('flo_name'))
}
/**
 * @param {string} username 
 */
export function setUserName(username = "") {
    store.commit("user/setUserName", username)
    localStorage.setItem('flo_username', JSON.stringify(username))
}
export function getUserName() {
    return JSON.parse(localStorage.getItem('flo_username'))
}
/**
 * @param {Array} roles 
 */
export function setRoles(roles = []) {
    store.commit('user/setRoles', roles)
}
export function getRoles() {
    return store.getters.roles
    // return JSON.parse(localStorage.getItem('flo_roles'))
}
/**
 * @param {Array} menus 
 */
export function setMenus(menus = []) {
    localStorage.setItem('flo_menu', JSON.stringify(menus))
}
export function getMenus() {
    return JSON.parse(localStorage.getItem('flo_menu'))
}

export function getUserInfo(token) {
    return new Promise((resolve, reject) => {
        if (token === getToken()) {
            axios.get('users/me').then(res => {
                if (res.status === 200) {
                    const { name, username, roles } = res.data
                    setName(name)
                    setUserName(username)
                    setRoles(roles)
                    resolve({ code: 200, roles })
                }
            }).catch(err => {
                resolve({ code: 401 })
                console.error('获取用户数据失败，请尝试重新登录！', err)
            })
        } else {
            resolve({ code: 401 })
        }

    })
}


/**
 * @param {Array} roles 
 * 根据用户全权限生成路由,如果是admin,则把所有的异步路由加载，不用过滤
 */
export function generateRoutes(roles) {
    return new Promise(resolve => {
        let accessedRoutes
        if (roles.includes('admin')) {
            accessedRoutes = ayscRoutes || []
        } else {
            accessedRoutes = filterAsyncRoutes(ayscRoutes, roles)
        }
        resolve(accessedRoutes)
    })
}

/**
 * 
 * @登出 
 */
export function logout() {
    localStorage.clear()
    store.commit("user/logout")
    resetRouter()
    return true
}

/**
 * @param {Array} targetRoles 目标数组
 * 检验规则，遍历目标数组里面的元素，如果目标数组里面至少有一个元素存在于源数组中，
 * 则代表有合法，有权限，否则就没有权限
 */
export function checkPermission(targetRoles = []) {
    return targetRoles.some(role => getRoles().includes(role))
}